import { CustomTable, Modal, EAsociationType, FilterDTO, MATCH_MODES, ResponseDTO, createFiltersForMobile, setNotification, stringFilterTemplate } from 'medere-ui-framework'
import { Button } from 'primereact/button'
import { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { Bank, initialStateBank } from '../../interface/interface';
import { Column } from 'primereact/column'
import BankCard from '../../components/BankCard'
import { AxiosResponse } from 'axios'
import { useDispatch } from 'react-redux'
import BankCRUDView from './BankCRUDView'
import { useBankService } from '../../servicesHooks/Bank/useBankService'

export default function BankListView() {

    const intl = useIntl();
    const dispatch = useDispatch();
    const { deleteBank, getAllBanks, bankHasBankAccounts } = useBankService();
    const [filterDTO, setFilterDTO] = useState<FilterDTO>({filters: [], associationType: EAsociationType.OR,filterLists:null });
    const tableRef = useRef<any>(null)
    const [openBankCRUDVisible, setOpenBankCRUDVisible] = useState(false)
    const [selectedBank, setSelectedBank] = useState<Bank>(initialStateBank)

    useEffect(()=>{
        if (!openBankCRUDVisible)
            setSelectedBank(initialStateBank)
    }, [openBankCRUDVisible])

    const closeModal = () => {
        setOpenBankCRUDVisible(false);
    };

    const refreshTable = () => {  
        if (tableRef)
            tableRef.current?.refreshTable();
    };

    const handleEdit = (b:Bank) => {
        setSelectedBank(b)
        setOpenBankCRUDVisible(true)
    }

    const handleDelete = (b:Bank) => {
        bankHasBankAccounts(b.bank).then((res) => {
            if (res.statusCode == 200)
                dispatch(setNotification({title:intl.formatMessage({id:"YouCanNotDeleteABankWithBankAccountsAssigned"}), icon:"pi-times"}))
            else
                deleteBank(b.bank).then((res:AxiosResponse)=>{
                    let data : ResponseDTO = res.data;
                    if(data.success){
                        tableRef.current?.removeRowByFieldName?.("bank",b.bank);
                        dispatch(setNotification({title:intl.formatMessage({id:"ChangesSaved"}),icon:"pi-check-circle"}))
                    }else{
                        dispatch(setNotification({title:intl.formatMessage({id:"ChangesCouldNotBeSaved"}), desc:data.errormessage,icon:"pi-times"}))
                    }
                })
        })
        
    }

    const handleFilterChange = (newValue:string) => {
        let _filterDTO:FilterDTO = createFiltersForMobile(newValue,
             [{
               fieldName: "companyname",
               filterType: MATCH_MODES.CONTAINS,           
             }
           ]);
           // Actualizar el estado utilizando el setter original
           setFilterDTO(_filterDTO);
     }

    return (
        <div className='flex flex-column h-full p-4 viewContainer'>
            <div className='flex flex-row justify-content-between'>
                <h2 style={{color: '#B67345', fontWeight: 600}} className="text-2xl mb-3">Disponibilidades</h2>
                <Button className='buttonMain p-button-rounded' icon="pi pi-plus" onClick={()=>setOpenBankCRUDVisible(true)}></Button>
           </div>
            <CustomTable
                idTable="banksTable"
                ref={tableRef}
                getItems={getAllBanks}
                params={{cardFilterDTO:filterDTO || null }}
                resizableColumns
                notFoundText={intl.formatMessage({id:"NoResultsFound"})}
                filterRow
                notFlex
                rowButtonClassName="buttonSecondary2TableButtons"
                CardTemplate={BankCard}
                cardKeyName="medereentity"
                cardEditBtn={{ className: 'buttonSecondary2', icon: 'pi-file-edit' }}
                cardDeleteBtn={{ className: 'buttonSecondary2', icon: 'pi-trash' }}
                handleMobileFilter={handleFilterChange}
                buttonController
                dropdownButton={{ edit: handleEdit, deleted: handleDelete }} 
            >
                {[<Column key={"companyname"} field="companyname" header={intl.formatMessage({id:"firstname"})} filter headerClassName="column" className="column" sortable filterElement={stringFilterTemplate} />]}
            </CustomTable>
            <Modal visible={openBankCRUDVisible} setVisible={setOpenBankCRUDVisible} header={JSON.stringify(selectedBank) === JSON.stringify(initialStateBank)? <div style={{color:'#B67345'}}>Agregar Banco</div>:<div style={{color:'#B67345'}}>Editar Banco</div> }>
                <BankCRUDView closeModal={closeModal} refreshTable={refreshTable} selectedBank={selectedBank}/>
            </Modal>
        </div>
  )
}
